<template>
  <div class="share-block">
    <div class="shares" v-on:mouseover="hover()" v-on:mouseleave="hide()">
      <div class="share-button" @click="isActive = !isActive"></div>
      <div class="shares-links" :class="{ active: this.isActive }">

        <social-sharing url="http://extra.afisha.ru"
                        title="Путь к успеху"
                        description="Узнайте, с какими неожиданными сложностями вы можете столкнуться в самый ответственный момент и как с ними справиться"
                        quote="Узнайте, с какими неожиданными сложностями вы можете столкнуться в самый ответственный момент и как с ними справиться"
                        v-cloak inline-template>
          <ul>
            <li @click="$ga.event('Шаринг', 'Шаринг вконтакте', 1)">
              <network network="vk" id="vk">
                <i class="icon-vkontakte"></i>
              </network>
            </li>

            <li @click="$ga.event('Шаринг', 'Шаринг facebook', 1)">
              <network network="facebook" id="facebook">
                <i class="icon-facebook"></i>
              </network>
            </li>
            <li @click="$ga.event('Шаринг', 'Шаринг twitter', 1)">
              <network network="twitter" id="twitter">
                <i class="icon-twitter"></i>
              </network>
            </li>
            <li @click="$ga.event('Шаринг', 'Шаринг одноклассники', 1)">
              <network network="odnoklassniki" id="odnoklassniki">
                <i class="icon-odnoklassniki"></i>
              </network>
            </li>
          </ul>
        </social-sharing>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareBlock",
  components: {},
  data() {
    return {
      isActive: false,
      timerId: null
    };
  },
  methods: {
    hover() {
      if (this.$mq.resize && this.$mq.above(769)) {
        this.isActive = true;
      }
    },
    hide() {
      clearTimeout(this.timerId);
      var that = this;
      this.timerId = setTimeout(function() {
        that.isActive = false;
      }, 500);
    },
    gaShare(social) {
      this.$ga.event("Шаринг", `Шаринг ${social}`, 1);
    }
  },
  computed: {
    aClass() {
      return this.isActive === true ? " active" : "";
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/icons.css";

.shares-links {
  display: flex;
  opacity: 0;
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  transform: translateX(-200px);
  &.active {
    visibility: visible;
    transition: all 0.3s ease;
    opacity: 1;
    transform: none;
    z-index: 1000;
  }
}

.share-button {
  background: url("../assets/img/share.png");
  background-repeat: no-repeat;
  width: 25px;
  height: 22px;
  background-size: contain;
  cursor: pointer;
  display: inline-flex;
}

.shares {
  display: inline-flex;
  transition: all 300ms ease-in-out;
  flex-direction: row-reverse;
  ul {
    display: flex;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      margin-left: 15px;
      margin-top: 4px;
    }
  }
}

@media screen and (max-width: 768px) {
  .shares {
    flex-direction: row;
  }
  .shares ul li {
    margin-left: 9px;
    margin-top: -3px;
  }
  .results-share .share-block .shares .shares-links li {
    margin-left: 0;
  }
  .results-share .share-block .shares .shares-links li:not(:last-child) {
    margin-right: 20px;
  }
  .results-share {
    margin-top: 0;
    padding-bottom: 25px;
  }
  .share-button {
    width: 16px;
    height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareBlock.vue